import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
        path: '/',
        redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/view/common/content'], resolve), // 主体
      children: [{
          path: '',
          component: resolve => require(['@/view/homePage'], resolve), //首页
      },
      {
        path: '/channels',
          component: resolve => require(['@/view/channels'], resolve), //渠道合作
      },
      {
        path: '/helpCenter',
          component: resolve => require(['@/view/helpCenter'], resolve), //帮助中心
      },
      {
        path: '/saasWeChat',
          component: resolve => require(['@/view/saasWeChat'], resolve), //小程序页
      },
      {
        path: '/aboutUs',
          component: resolve => require(['@/view/aboutUs'], resolve), //关于我们
      },
      {
        path: '/registeredOrlogin',
          component: resolve => require(['@/view/registeredOrlogin'], resolve), //注册登录
      },
    ]},
    {
      path:'/registerWord',
      component: resolve => require(['@/view/registerWord'], resolve), //注册时文档
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js